export default __webpack_public_path__ + "130e831d023bba73edb1dc2685a509e1.png";